module.exports = __webpack_public_path__ + "static/media/19-1.6cb6640f.mp3";